import { Typography } from '@remarkable/ark-web';
import { Divider, Feedback } from 'src/components';
import { AppPage } from 'src/components/AppPage';
import { Boundary } from 'src/components/Boundary';
import { TestId } from 'src/testids';
import { CancelEnterpriseSubscription } from '../components/CancelEnterpriseSubscription';
import { EnterpriseBilling } from '../components/EnterpriseBilling';

export function EnterpriseBillingPage() {
  return (
    <>
      <AppPage.Header
        className="w-full justify-start px-16 text-left lm:px-32"
        title="Billing"
      />
      <AppPage.Content
        className="max-w-l2xl"
        data-cy={TestId.PageEnterpriseMembers}
      >
        <div className="flex flex-col gap-32">
          <Boundary
            renderError={() => (
              <div>
                <Typography as="h2" variant="body-lg" className="font-semibold">
                  Subscription not available
                </Typography>
              </div>
            )}
          >
            <EnterpriseBilling />
          </Boundary>

          <Divider />

          <CancelEnterpriseSubscription />
        </div>
        <Feedback
          feedbackTargetId="enterprise-billing-page"
          title="Did you find what you were looking for?"
        />
      </AppPage.Content>
    </>
  );
}
